import { reduce } from '@atlaskit/adf-utils/traverse';

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function countNodes(adfDocument) {
  return reduce(adfDocument, function (acc, node) {
    acc[node.type] = (acc[node.type] || 0) + 1;
    return acc;
  }, {});
}